import { useContext } from 'react';
import { StoreContext } from '@roc/client-portal-shared/context';
import { ClientPortalBaseStore } from '../stores';

export const useStore = () => useContext<ClientPortalBaseStore>(StoreContext);
